import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = async () => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const headers = {};
  if (currentUser) {
    const token = await currentUser.getIdToken();
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export async function getOrgVerificationStatus() {
  const headers = await getAuthHeaders();
  const response = await axios.get(
    `${API_BASE_URL}/api/org-verification/status/`,
    { headers }
  );
  return response.data;
}

export async function startOrgVerification(data) {
  const headers = await getAuthHeaders();
  const response = await axios.post(
    `${API_BASE_URL}/api/org-verification/start/`,
    data,
    { headers }
  );
  return response.data;
}

export async function uploadOrgVerificationDocument(documentType, file) {
  const headers = await getAuthHeaders();

  const formData = new FormData();
  formData.append("document_type", documentType);
  formData.append("document", file, file.name);

  const response = await axios.post(
    `${API_BASE_URL}/api/org-verification/upload-document/`,
    formData,
    {
      headers: {
        ...headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export async function submitOrgVerification() {
  const headers = await getAuthHeaders();
  const response = await axios.post(
    `${API_BASE_URL}/api/org-verification/submit/`,
    {},
    { headers }
  );
  return response.data;
}
